import type { JSX } from 'react'
import KootstraIcon from './kootstra'
import classNames from 'classnames'

export default function HomeKootstraIcon ({ className }: { className?: string }): JSX.Element {
  return (
    <KootstraIcon
      className={classNames(className, 'size-8 rounded-full')}
      viewBox='4 4 17 17'
    />
  )
}
